// extracted by mini-css-extract-plugin
export default {"admin-link":"AdminLink_admin-link__nG8cT"};